import React, { useEffect, useState } from "react";
import FileInput from "./form_fields/FileInput";
import RadioInput from "./form_fields/RadioInput";
import BaseFormComponent from "./form_fields/BaseFormComponent";
import SelectInput from "./form_fields/SelectInput";
import Select from 'react-select';
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useDropdownStore } from "./store/useDropdownStore";
import { Formik, Form, ErrorMessage, Field } from "formik";
import FilePreview from "./FilePreview";
import { useVehicleStore } from "./store/useVehicleStore";
import getValidationSchema from "./getValidationSchema";
import { waveform } from "ldrs";
import { handleUuid } from "../../../utils/ValidationsHelper";
import { getWritePermission } from "./utils/helpers";
const AddVehicleForm = ({
  handleSearch,
  editVehicleData,
  setEditVehicleData,
  handleClose,
}) => {
  console.log(editVehicleData)
  const {
    fuelTypes,
    collectionTypes,
    vehicleTypes,
    ownerTypes,
    vehicleCapacities,
    zones,
    circles,
    wards,
    drivers,
    primaryDeploymentIncharges,
    secondaryDeploymentIncharges,
    transferStations,
    loading,
    vehicleStatus,
    fileInputs,
    filePreviews,
    resetFileInputs,
    fetchVehicleTypes,
    fetchOwnerTypes,
    fetchVehicleCapacities,
    fetchVehicleStatus,
    fetchFuelTypes,
    fetchCollectionTypes,
    fetchZones,
    fetchCircles,
    fetchWards,
    fetchDrivers,
    fetchPrimaryDeploymentIncharges,
    fetchSecondaryDeploymentIncharges,
    fetchTransferStations,
    handleFileChange,
    updateFilePreview,
  } = useDropdownStore();
  const canWrite = getWritePermission();
  const {
    saveVehicleDetails,
    fetchVehicleDetails,
    vehicleDetails,
    isSaveVehicleDetailsLoading,
    error,
    success,
  } = useVehicleStore();

  useEffect(() => {
    fetchFuelTypes();
    fetchCollectionTypes();
    fetchVehicleStatus();
    fetchOwnerTypes();
    fetchZones();
    fetchDrivers();
    fetchPrimaryDeploymentIncharges();
    fetchSecondaryDeploymentIncharges();
    fetchTransferStations();
    if (editVehicleData) {
      fetchVehicleTypes(editVehicleData?.collectionTypeId);
      fetchVehicleCapacities(editVehicleData?.vehicleTypeId);
      fetchCircles(editVehicleData?.zoneId);
      fetchWards(editVehicleData?.circleId);
      fetchDrivers(editVehicleData?.collectionTypeId);
      updateFilePreview(
        editVehicleData?.vehicleImageUrl ?? null,
        editVehicleData?.rcimageUrl ?? null,
        editVehicleData?.pcimageUrl ?? null
      );
    }
  }, [editVehicleData]);

  // const getValidationSchema = (collectionTypeId, isEditMode) => {
  //   return Yup.object().shape({
  //     zoneId: Yup.string().required("Zone is required"),
  //     circleId:
  //       [1, 2].includes(Number(collectionTypeId))
  //         ? Yup.string().required("Circle is required")
  //         : Yup.string(),
  //   wardId: isEditMode
  //     ? Yup.string().required("Ward is required when updating")
  //     : Yup.string(),
  // });
  // };

  const initialVehicleDetails = {
    vehicleNumber: editVehicleData?.vehicleNumber || "",
    chassisNumber: editVehicleData?.chassisNumber || "",
    fuelTypeId: editVehicleData?.fuelTypeId || "",
    collectionTypeId: editVehicleData?.collectionTypeId || "",
    vehicleTypeId: editVehicleData?.vehicleTypeId || "",
    vehicleCapacityId: editVehicleData?.vehicleCapacityId || "",
    vehicleStatusId: editVehicleData?.vehicleStatusId || "",
    ownerTypeId: editVehicleData?.ownerTypeId || "",
    vehicleUuid: editVehicleData?.vehicleUuid || "",
    zoneId: editVehicleData?.zoneId || "",
    circleId: editVehicleData?.circleId || "",
    wardId: editVehicleData?.wardId || "",
    driverId: editVehicleData?.driverId || "",
    RFID: editVehicleData?.rfid || "",
    primaryDeploymentInchargeId:
      editVehicleData?.primaryDeploymentInchargeId || "",
    secondaryDeploymentInchargeId:
      editVehicleData?.secondaryDeploymentInchargeId || "",
    transferStationId: editVehicleData?.transferStationId || "",
    vehicleImageUrl: null,
    rcimageUrl: null,
    pcimageUrl: null,
    vehicleBrandName: editVehicleData?.vehicleBrandName || "",
    contractorName: editVehicleData?.contractorName || "",
    remark: editVehicleData?.remark || "",
    isActive: editVehicleData?.isActive || true ,
    //
    fuelTypeName: editVehicleData?.fuelTypeName || "",
    collectionTypeName: editVehicleData?.collectionTypeName || "",

    ownerTypeName: editVehicleData?.ownerTypeName || "",
    transferStationName: editVehicleData?.transferStationName || "",

    vehicleTypeName: editVehicleData?.vehicleTypeName || "",
    vehicleCapacityName: editVehicleData?.vehicleCapacityName || "",
    vehicleStatusName: editVehicleData?.vehicleStatusName || "",

    DriverNumber: editVehicleData?.driverNumber || "",
    DriverName: editVehicleData?.driverName || "",

    PrimaryDeploymentInchargeName:
      editVehicleData?.primaryDeploymentInchargeName || "",
    PrimaryDeploymentInchargeNumber:
      editVehicleData?.primaryDeploymentInchargeNumber || "",

    SecondaryDeploymentInchargeNumber:
      editVehicleData?.SecondaryDeploymentInchargeNumber || "",
    SecondaryDeploymentInchargeName:
      editVehicleData?.secondaryDeploymentInchargeName || "",
    //
    ...(editVehicleData?.vehicleId && { vehicleId: editVehicleData.vehicleId }),
  };

  const [collectionTypeId, setCollectionTypeId] = useState(
    initialVehicleDetails.collectionTypeId
  );
  const [isSubmit, setIsSubmit] = useState(false);
  waveform.register();

  const handleSubmit = async (values, resetForm, setErrors) => {
    // console.log("Form Submitted Values:", values);
    // console.log("Uploaded Files:", fileInputs);
    setIsSubmit(true);
    const formattedValues = {
      ...values,
      wardId: values.wardId ? values.wardId : undefined,
      PrimaryDeploymentInchargeName:
        values.collectionTypeId === "2" ? "" : values.PrimaryDeploymentInchargeName,
      PrimaryDeploymentInchargeNumber:
        values.collectionTypeId === "2" ? "" : values.PrimaryDeploymentInchargeNumber,
      SecondaryDeploymentInchargeNumber:
        values.collectionTypeId === "1" ? "" : values.SecondaryDeploymentInchargeNumber,
      SecondaryDeploymentInchargeName:
        values.collectionTypeId === "1" ? "" : values.SecondaryDeploymentInchargeName,
    };
    try {
      const response = await saveVehicleDetails(formattedValues, editVehicleData);
      handleSearch();
      toast.success(
        editVehicleData
          ? "Vehicle updated successfully"
          : "New Vehicle added successfully"
      );
      setEditVehicleData(null);
      handleClose();
      resetFileInputs();
      setIsSubmit(false);
    } catch (xhr) {
      console.log("xhr.errors:", xhr);
      if (xhr && xhr.response && typeof xhr.response.data.errors === "object") {
        const formErrors = {};
        Object.keys(xhr.response.data.errors).forEach((key) => {
          if (
            Array.isArray(xhr.response.data.errors[key]) &&
            xhr.response.data.errors[key].length > 0
          ) {
            formErrors[key] = xhr.response.data.errors[key][0];
            console.log(`${key}: ${xhr.response.data.errors[key][0]}`);
            toast.error(`${key}: ${xhr.response.data.errors[key][0]}`);
          }
        });
      } else {
        toast.error(xhr.response.data);
      }
      setIsSubmit(false);
    }
    resetForm();
  };

  const handleSpecialCharacters = (e) => {
    const value = e.target.value;

    // Allow only alphanumeric characters and single spaces between words
    const sanitizedValue = value
      .replace(/[^a-zA-Z0-9\s]/g, "") // Remove special characters except spaces
      .replace(/^\s+/, "") // Remove leading spaces
      .replace(/\s{2,}/g, " "); // Replace multiple spaces with a single space

    e.target.value = sanitizedValue;
  };


  return (
    <div>
      <Formik
        initialValues={initialVehicleDetails}
        validationSchema={getValidationSchema(collectionTypeId, editVehicleData)}
        onSubmit={handleSubmit}
        validateOnChange={true}
        validateOnBlur={true}
      >
        {({
          values,
          setFieldValue,
          setFieldError,
          resetForm,
          setFieldTouched,
          setErrors,
          setTouched,
        }) => (
          <Form>
            <div className="row">
              {/* Vehicle Number */}
              <BaseFormComponent
                label="Vehicle Number"
                name="vehicleNumber"
                type="text"
                // max="12"
                placeholder="Enter Vehicle Registration Number"
                required
              />
              {/* Vehicle Chassis Number */}
              <BaseFormComponent
                label="Vehicle Chassis Number"
                name="chassisNumber"
                type="text"
                max="30"
                handleSpecialCharacters={handleSpecialCharacters}
                placeholder="Enter Vehicle Chassis Number"
              // required
              />
              {/* Fuel Type */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Fuel Type
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    name="fuelTypeId"
                    className="form-select"
                    onChange={(e) => {
                      const selectedFuelTypeId = e.target.value;
                      setFieldValue("fuelTypeId", selectedFuelTypeId);
                      setFieldTouched("fuelTypeId", false); // Mark field as not touched
                      setFieldError("fuelTypeId", ""); // Clear error message

                      const selectedFuelType = fuelTypes.find(
                        (fuelType) =>
                          fuelType.fuelTypeId === Number(selectedFuelTypeId)
                      );

                      if (selectedFuelType) {
                        setFieldValue(
                          "fuelTypeName",
                          selectedFuelType.fuelTypeName
                        );
                      }
                    }}
                  >
                    <option value="">Select</option>
                    {fuelTypes.map((fuelType) => (
                      <option
                        key={fuelType.fuelTypeId}
                        value={fuelType.fuelTypeId}
                      >
                        {fuelType.fuelTypeName}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="fuelTypeId"
                    component="span"
                  />
                </div>
              </div>
              {/* Collection Type */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Collection Type
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    name="collectionTypeId"
                    className="form-select"
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      const previousValue = values.collectionTypeId;

                      setFieldValue("collectionTypeId", selectedValue);
                      setFieldTouched("collectionTypeId", false); // Mark field as not touched
                      setFieldError("collectionTypeId", ""); // Clear error message

                      if (previousValue === "1" && selectedValue !== "1") {
                        setFieldValue("driverId", "");
                        setFieldTouched("driverId", false);
                        setFieldError("driverId", "");
                      }
                      if (selectedValue) {
                        setCollectionTypeId(selectedValue);
                        fetchVehicleTypes(selectedValue);
                        fetchDrivers(selectedValue);

                        if (selectedValue === "1") {
                          fetchPrimaryDeploymentIncharges();
                        } else if (selectedValue === "2") {
                          fetchSecondaryDeploymentIncharges();
                        }
                      }

                      // Find the selected collection type name and set it
                      const selectedCollectionType = collectionTypes.find(
                        (collectionType) =>
                          collectionType.collectionTypeId === Number(selectedValue)
                      );

                      if (selectedCollectionType) {
                        setFieldValue("collectionTypeName", selectedCollectionType.collectionTypeName);
                      }
                    }}
                  >

                    <option value="">Select</option>
                    {collectionTypes.map((collectionType) => (
                      <option
                        key={collectionType.collectionTypeId}
                        value={collectionType.collectionTypeId}
                      >
                        {collectionType.collectionTypeName}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="collectionTypeId"
                    component="span"
                  />
                </div>
              </div>
              {/* Vehicle Type */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Vehicle Type
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    name="vehicleTypeId"
                    className="form-select"
                    onChange={(e) => {
                      setFieldValue("vehicleTypeId", e.target.value);
                      setFieldTouched("vehicleTypeId", false); // Mark field as not touched
                      setFieldError("vehicleTypeId", ""); // Clear error message
                      if (e.target.value) {
                        fetchVehicleCapacities(e.target.value);
                      }

                      const selectedVehicleTypeId = e.target.value;
                      const selectedVehicleType = vehicleTypes.find(
                        (vehicleType) =>
                          vehicleType.vehicleTypeId ===
                          Number(selectedVehicleTypeId)
                      );

                      if (selectedVehicleType) {
                        setFieldValue(
                          "vehicleTypeName",
                          selectedVehicleType.vehicleTypeName
                        );
                      }
                    }}
                  >
                    <option value="">Select</option>
                    {vehicleTypes
                      .filter((vehicleType) => vehicleType.isActive)
                      .map((vehicleType) => (
                        <option
                          key={vehicleType.vehicleTypeId}
                          value={vehicleType.vehicleTypeId}
                        >
                          {vehicleType.vehicleTypeName}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="vehicleTypeId"
                    component="span"
                  />
                </div>
              </div>
              {/* Vehicle Capacity */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Vehicle Capacity
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    name="vehicleCapacityId"
                    className="form-select"
                    onChange={(e) => {
                      const selectedVehicleCapacityId = e.target.value;
                      setFieldValue("vehicleCapacityId", e.target.value);
                      setFieldTouched("vehicleCapacityId", false); // Mark field as not touched
                      setFieldError("vehicleCapacityId", ""); // Clear error message
                      const selectedVehicleCapacity = vehicleCapacities.find(
                        (vehicleCapacity) =>
                          vehicleCapacity.vehicleCapacityId ===
                          Number(selectedVehicleCapacityId)
                      );

                      if (selectedVehicleCapacity) {
                        setFieldValue(
                          "vehicleCapacityName",
                          selectedVehicleCapacity.vehicleCapacityName
                        );
                      }
                    }}
                  >
                    <option value="">Select</option>
                    {vehicleCapacities
                      .filter((vehicleCapacity) => vehicleCapacity.isActive)
                      .map((vehicleCapacity) => (
                        <option
                          key={vehicleCapacity.vehicleCapacityId}
                          value={vehicleCapacity.vehicleCapacityId}
                        >
                          {vehicleCapacity.vehicleCapacityName}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="vehicleCapacityId"
                    component="span"
                  />
                </div>
              </div>
              {/* Vehicle Status */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Vehicle Status
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    name="vehicleStatusId"
                    className="form-select"
                    onChange={(e) => {
                      const selectedVehicleStatusId = e.target.value;
                      setFieldValue("vehicleStatusId", e.target.value);
                      setFieldTouched("vehicleStatusId", false); // Mark field as not touched
                      setFieldError("vehicleStatusId", ""); // Clear error message
                      const selectedVehicleStatus = vehicleStatus.find(
                        (vehicleStatus) =>
                          vehicleStatus.vehicleStatusId ===
                          Number(selectedVehicleStatusId)
                      );
                      Number(selectedVehicleStatusId) === 2
                        ? setFieldValue("isActive", false)
                        : setFieldValue("isActive", true);

                      setFieldValue(
                        "vehicleStatusName",
                        selectedVehicleStatus?.vehicleStatusName
                      );
                    }}
                  >
                    <option value="">Select</option>
                    {vehicleStatus.map((status) => (
                      <option
                        key={status.vehicleStatusId}
                        value={status.vehicleStatusId}
                      >
                        {status.vehicleStatusName}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="vehicleStatusId"
                    component="span"
                  />
                </div>
              </div>
              {/* Owner Type */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Owner Type
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    name="ownerTypeId"
                    className="form-select"
                    onChange={(e) => {
                      const selectedOwnerTypeId = e.target.value;
                      setFieldValue("ownerTypeId", e.target.value);
                      setFieldTouched("ownerTypeId", false); // Mark field as not touched
                      setFieldError("ownerTypeId", ""); // Clear error message
                      const selectedOwnerType = ownerTypes.find(
                        (ownerType) =>
                          ownerType.ownerTypeId === Number(selectedOwnerTypeId)
                      );

                      if (selectedOwnerType) {
                        setFieldValue(
                          "ownerTypeName",
                          selectedOwnerType.ownerTypeName
                        );
                      }
                    }}
                  >
                    <option value="">Select</option>
                    {ownerTypes
                      .filter((owner) => owner.isActive)
                      .map((owner) => (
                        <option key={owner.ownerTypeId} value={owner.ownerTypeId}>
                          {owner.ownerTypeName}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="ownerTypeId"
                    component="span"
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Vehicle UID
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    type="text"
                    id="vehicleUuid"
                    maxLength="20"
                    name="vehicleUuid"
                    onInput={handleUuid}
                    className="form-control"
                    placeholder="Enter Vehicle UID"
                  />
                  <ErrorMessage
                    className="form-text text-danger"
                    name="vehicleUuid"
                    component="span"
                  />
                </div>
              </div>
              {/* Zone */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Zone
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    name="zoneId"
                    className="form-select"
                    onChange={(e) => {
                      setFieldValue("zoneId", e.target.value);
                      setFieldValue("circleId", "");
                      setFieldValue("wardId", "");
                      setFieldTouched("zoneId", false); // Mark field as not touched
                      setFieldError("zoneId", ""); // Clear error message
                      if (e.target.value) {
                        fetchCircles(e.target.value);
                        fetchWards(e.target.value)
                      } else {
                        fetchCircles([]);

                        fetchWards([]);
                      }
                    }}
                  >
                    <option value="">Select</option>
                    {zones
                      .filter((zone) => zone.isActive)
                      .map((zone) => (
                        <option key={zone.zoneId} value={zone.zoneId}>
                          {zone.zoneName}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="zoneId"
                    component="span"
                  />
                </div>
              </div>
              {/* Circle */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Circle
                    {[1, 2].includes(Number(values.collectionTypeId)) && (
                      <span style={{ color: "#EC1117" }}> *</span>
                    )}
                  </label>
                  <Field
                    as="select"
                    name="circleId"
                    className="form-select"
                    onChange={(e) => {
                      setFieldValue("circleId", e.target.value);
                      setFieldValue("wardId", "");
                      setFieldTouched("circleId", false); // Mark field as not touched
                      setFieldError("circleId", ""); // Clear error message
                      if (e.target.value) {
                        fetchWards(e.target.value);
                      } else {
                        fetchWards([]);
                      }
                    }}
                  // disabled={circles.length === 0}
                  >
                    <option value="">Select</option>
                    {Array.isArray(circles) && circles.length > 0 ? (
                      circles.map((circle) => (
                        <option key={circle.circleId} value={circle.circleId}>
                          {circle.circleName}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No circles found
                      </option>
                    )}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="circleId"
                    component="span"
                  />
                </div>
              </div>
              {/* Ward */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Ward
                    {[1].includes(Number(values.collectionTypeId)) && (
                      <span style={{ color: "#EC1117" }}> *</span>
                    )}
                  </label>
                  <Field as="select" name="wardId" className="form-select" disabled={!wards.length}>
                    <option value="">Select</option>
                    {Array.isArray(wards) && wards.length > 0 ? (
                      wards
                        .filter((ward) => ward.isActive)
                        .map((ward) => (
                          <option key={ward.wardId} value={ward.wardId}>
                            {ward.wardName}
                          </option>
                        ))
                    ) : (
                      <option value="" disabled>
                        No Wards found
                      </option>
                    )
                    }
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="wardId"
                    component="span"
                  />
                </div>
              </div>
              {/* Driver Selection */}
              <div className="col-md-4">
                <div className="form-group" title={values.DriverName+" "+values.DriverNumber}>
                  <label className="form-label">
                    Driver Name
                    {[1].includes(Number(values.collectionTypeId)) && (
                      <span style={{ color: "#EC1117" }}> *</span>
                    )}
                  </label>
                  <Field name="driverId">
                    {({ field, form }) => (
                      <Select
                        {...field}
                        options={drivers
                          .filter((driver) => driver.isActive)
                          .map((driver) => ({
                            value: driver.driverId,
                            label: `${driver.driverName} [${driver.mobileNumber}]`,
                          }))}
                        classNamePrefix="CreatableSelect"
                        placeholder="Select"
                        value={drivers
                          .filter((driver) => driver.isActive)
                          .map((driver) => ({
                            value: driver.driverId,
                            label: `${driver.driverName} [${driver.mobileNumber}]`,
                          }))
                          .find((option) => option.value === field.value)}
                        onChange={(selectedOption) => {
                          const selectedDriverId = selectedOption ? selectedOption.value : '';
                          form.setFieldValue('driverId', selectedDriverId);
                          const selectedDriver = drivers.find(
                            (driver) => driver.driverId === Number(selectedDriverId)
                          );
                          if (selectedDriver) {
                            setFieldValue('DriverName', selectedDriver.driverName);
                            setFieldValue('DriverNumber', selectedDriver.mobileNumber);
                            setFieldTouched('driverId', false);
                            setFieldError('driverId', '');
                          } else {
                            setFieldValue('DriverName', '');
                            setFieldValue('DriverNumber', '');
                          }
                        }}
                        onBlur={() => setFieldTouched('driverId', true)}
                        isClearable={true}
                        isSearchable={true}

                      />
                    )}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="driverId"
                    component="span"
                  />
                </div>
              </div>

              {/* Deployment Incharge Selection */}
              {Number(values.collectionTypeId) === 1 && (
                <div className="col-md-4">
                  <div className="form-group" title={values.PrimaryDeploymentInchargeName+" "+values.PrimaryDeploymentInchargeNumber}>
                    <label className="form-label">
                      SFA incharge
                      <span style={{ color: "#EC1117" }}> *</span>
                    </label>
                    <Field name="primaryDeploymentInchargeId">
                      {({ field, form }) => (
                        <Select
                          {...field}
                          options={primaryDeploymentIncharges
                            .filter((incharge) => incharge.isActive)
                            .map((incharge) => ({
                              value: incharge.primaryDeploymentInchargeId,
                              label: `${incharge.primaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
                            }))}
                          // className="form-select"
                          classNamePrefix="CreatableSelect"
                          placeholder="Select"
                          value={primaryDeploymentIncharges
                            .filter((incharge) => incharge.isActive)
                            .map((incharge) => ({
                              value: incharge.primaryDeploymentInchargeId,
                              label: `${incharge.primaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
                            }))
                            .find((option) => option.value === field.value)}
                          onChange={(selectedOption) => {
                            const selectedPrimaryDeploymentInchargeId = selectedOption ? selectedOption.value : '';
                            form.setFieldValue('primaryDeploymentInchargeId', selectedPrimaryDeploymentInchargeId);
                            const selectedIncharge = primaryDeploymentIncharges.find(
                              (incharge) => incharge.primaryDeploymentInchargeId === Number(selectedPrimaryDeploymentInchargeId)
                            );
                            if (selectedIncharge) {
                              setFieldValue('PrimaryDeploymentInchargeName', selectedIncharge.primaryDeploymentInchargeName);
                              setFieldValue('PrimaryDeploymentInchargeNumber', selectedIncharge.mobileNumber);
                              setFieldTouched('primaryDeploymentInchargeId', false);
                              setFieldError('primaryDeploymentInchargeId', '');
                            } else {
                              setFieldValue('PrimaryDeploymentInchargeName', '');
                              setFieldValue('PrimaryDeploymentInchargeNumber', '');
                            }
                          }}
                          onBlur={() => setFieldTouched('primaryDeploymentInchargeId', true)}
                          isClearable={true}
                          isSearchable={true}
                        />
                      )}
                    </Field>
                    <ErrorMessage
                      className="form-text text-danger"
                      name="primaryDeploymentInchargeId"
                      component="span"
                    />
                  </div>
                </div>
              )}
              {/* Secondary Deployment Incharge */}
              {Number(values.collectionTypeId) === 2 && (
                <div className="col-md-4">
                  <div className="form-group" title={values.SecondaryDeploymentInchargeName+" "+values.SecondaryDeploymentInchargeNumber}>
                    <label className="form-label">
                      Secondary Incharge
                    </label>
                    <Field name="secondaryDeploymentInchargeId">
                      {({ field, form }) => (
                        <Select
                          {...field}
                          options={secondaryDeploymentIncharges
                            .filter((incharge) => incharge.isActive)
                            .map((incharge) => ({
                              value: incharge.secondaryDeploymentInchargeId,
                              label: `${incharge.secondaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
                            }))}
                          classNamePrefix="CreatableSelect"
                          placeholder="Select"
                          value={secondaryDeploymentIncharges
                            .filter((incharge) => incharge.isActive)
                            .map((incharge) => ({
                              value: incharge.secondaryDeploymentInchargeId,
                              label: `${incharge.secondaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
                            }))
                            .find((option) => option.value === field.value)}
                          onChange={(selectedOption) => {
                            const selectedSecondaryDeploymentInchargeId = selectedOption ? selectedOption.value : '';
                            form.setFieldValue('secondaryDeploymentInchargeId', selectedSecondaryDeploymentInchargeId);
                            const selectedIncharge = secondaryDeploymentIncharges.find(
                              (incharge) => incharge.secondaryDeploymentInchargeId === Number(selectedSecondaryDeploymentInchargeId)
                            );
                            if (selectedIncharge) {
                              form.setFieldValue('SecondaryDeploymentInchargeName', selectedIncharge.secondaryDeploymentInchargeName);
                              form.setFieldValue('SecondaryDeploymentInchargeNumber', selectedIncharge.mobileNumber);
                              form.setFieldTouched('secondaryDeploymentInchargeId', false);
                              form.setFieldError('secondaryDeploymentInchargeId', '');
                            } else {
                              form.setFieldValue('SecondaryDeploymentInchargeName', '');
                              form.setFieldValue('SecondaryDeploymentInchargeNumber', '');
                            }
                          }}
                          onBlur={() => form.setFieldTouched('secondaryDeploymentInchargeId', true)}
                          isClearable={true}
                          isSearchable={true}
                        />
                      )}
                    </Field>



                    <ErrorMessage
                      className="form-text text-danger"
                      name="secondaryDeploymentInchargeId"
                      component="span"
                    />
                  </div>
                </div>
              )}

              {/* Transfer Station Selection */}
              <div className="col-md-4">
                <div className="form-group" title={values.transferStationName}>
                  <label className="form-label">
                    Transfer Station
                  </label>
                  <Field name="transferStationId">
                    {({ field, form }) => (
                      <Select
                        {...field}
                        options={transferStations
                          .filter((station) => station.isActive)
                          .map((station) => ({
                            value: station.transferStationId,
                            label: station.transferStationName,
                          }))}
                        classNamePrefix="CreatableSelect"
                        placeholder="Select"
                        value={transferStations
                          .filter((station) => station.isActive)
                          .map((station) => ({
                            value: station.transferStationId,
                            label: station.transferStationName,
                          }))
                          .find((option) => option.value === field.value)}
                        onChange={(selectedOption) => {
                          const selectedTransferStationId = selectedOption ? selectedOption.value : '';
                          form.setFieldValue('transferStationId', selectedTransferStationId);
                          const selectedStation = transferStations.find(
                            (station) => station.transferStationId === Number(selectedTransferStationId)
                          );
                          if (selectedStation) {
                            form.setFieldValue('transferStationName', selectedStation.transferStationName);
                            form.setFieldTouched('transferStationId', false);
                            form.setFieldError('transferStationId', '');
                          } else {
                            form.setFieldValue('transferStationName', '');
                          }
                        }}
                        onBlur={() => form.setFieldTouched('transferStationId', true)}
                        isClearable={true}
                        isSearchable={true}
                      />
                    )}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="transferStationId"
                    component="span"
                  />
                </div>
              </div>
              {/* File Uploads */}
              {/* ******************************** */}
              <div className="col-12">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="vehicleImageUrl" className="form-label">
                        Vehicle Insurance
                      </label>
                      <input
                        type="file"
                        id="vehicleImageUrl"
                        name="vehicleImageUrl"
                        accept=".png, .jpg, .jpeg"
                        onChange={(e) => {
                          handleFileChange(e, "vehicleImageUrl");
                          setFieldValue(
                            "vehicleImageUrl",
                            e.currentTarget.files[0]
                          );
                        }}
                        className="form-control"
                      />
                      <ErrorMessage
                        className="form-text text-danger"
                        name="vehicleImageUrl"
                        component="span"
                      />
                      {filePreviews.vehicleImageUrl?.fileUrl && (
                        <FilePreview
                          file={filePreviews.vehicleImageUrl.file}
                          fileType={filePreviews.vehicleImageUrl.fileType}
                          fileUrl={filePreviews.vehicleImageUrl.fileUrl}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="rcimageUrl" className="form-label">
                        Registration Certificate
                      </label>
                      <input
                        type="file"
                        id="rcimageUrl"
                        name="rcimageUrl"
                        accept="image/png, image/jpeg ,image/jpg"
                        onChange={(e) => {
                          handleFileChange(e, "rcimageUrl");
                          setFieldValue("rcimageUrl", e.currentTarget.files[0]);
                        }}
                        className="form-control"
                      />
                      <ErrorMessage
                        className="form-text text-danger"
                        name="rcimageUrl"
                        component="span"
                      />
                      {filePreviews.rcimageUrl?.fileUrl && (
                        <FilePreview
                          file={filePreviews.rcimageUrl.file}
                          fileType={filePreviews.rcimageUrl.fileType}
                          fileUrl={filePreviews.rcimageUrl.fileUrl}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="pcimageUrl" className="form-label">
                        Pollution Certificate
                      </label>
                      <input
                        type="file"
                        id="pcimageUrl"
                        name="pcimageUrl"
                        accept=".png, .jpg, .jpeg"
                        onChange={(e) => {
                          handleFileChange(e, "pcimageUrl");
                          setFieldValue("pcimageUrl", e.currentTarget.files[0]);
                        }}
                        className="form-control"
                      />
                      <ErrorMessage
                        className="form-text text-danger"
                        name="pcimageUrl"
                        component="span"
                      />
                      {filePreviews.pcimageUrl?.fileUrl && (
                        <FilePreview
                          file={filePreviews.pcimageUrl.file}
                          fileType={filePreviews.pcimageUrl.fileType}
                          fileUrl={filePreviews.pcimageUrl.fileUrl}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* ******************************** */}

              {/* Vehicle Brand Name */}
              <BaseFormComponent
                label="Vehicle Brand Name"
                name="vehicleBrandName"
                type="text"
                placeholder="Enter Vehicle Brand Name"
                max="42"
                handleSpecialCharacters={handleSpecialCharacters}
              />

              {/* Contractor Name */}
              <BaseFormComponent
                label="Contractor Name"
                name="contractorName"
                type="text"
                placeholder="Enter Contractor Name"
                max="42"
                handleSpecialCharacters={handleSpecialCharacters}
              />
              {/* RFID */}
              <BaseFormComponent
                label="RFID"
                name="RFID"
                type="text"
                placeholder="Enter RFID"
                max="12"
                handleSpecialCharacters={handleSpecialCharacters}
              />
              {/* Remarks */}
              <div className="col-md-12 mb-3">
                <div className="form-group">
                  <label htmlFor="remark" className="form-label">
                    Remarks
                  </label>
                  <Field
                    as="textarea"
                    id="remark"
                    name="remark"
                    className="form-control"
                    maxLength="500"
                    rows="3"
                  />
                </div>
                <ErrorMessage
                  className="form-text text-danger"
                  name="remark"
                  component="span"
                />
              </div>

              <div className="row" style={{ marginTop: "5px" }}>
                <div className="col-md-4">
                  <label className="form-label">Status <span style={{ color: "#EC1117" }}> *</span></label>
                  <div className="d-flex gap-4">
                    <div className="form-group d-flex justify-content-center align-items-center gap-2">
                      <div className="radio-button-group">
                        <Field name="isActive">
                          {({ field }) => (
                            <input
                              type="radio"
                              id="active"
                              {...field}
                              value={true}
                              checked={values.isActive === true}
                              onChange={() => setFieldValue("isActive", true)}
                            />
                          )}
                        </Field>
                      </div>
                      <label htmlFor="active">Active</label>
                    </div>

                    <div className="form-group d-flex justify-content-center align-items-center gap-2">
                      <div className="radio-button-group">
                        <Field name="isActive">
                          {({ field }) => (
                            <input
                              type="radio"
                              id="inactive"
                              {...field}
                              value={false}
                              checked={values.isActive === false}
                              onChange={() => setFieldValue("isActive", false)}
                            />
                          )}
                        </Field>
                      </div>
                      <label htmlFor="inactive">Inactive</label>
                    </div>
                  </div>

                  {/* Display Validation Error if needed */}
                  <ErrorMessage
                    className="form-text text-danger"
                    name="isActive"
                    component="span"
                  />
                </div>
              </div>
              {/* Submit Button */}
              <div className="modal-footer d-flex justify-content-center">
                {canWrite === true ? (
                  <button
                    type="submit"
                    className="deployment-button"
                    disabled={isSubmit}
                  >
                    {isSubmit ? (
                      <l-waveform
                        size="20"
                        stroke="3.5"
                        speed="1"
                        color="black"
                      ></l-waveform>
                    ) : (
                      <>
                        <i className="fa-solid fa-check done-container"></i>
                        {editVehicleData ? "Update" : "Save"}
                      </>
                    )}
                  </button>
                ) : (
                  ""
                )}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddVehicleForm;
